<template>
  <v-container fluid>
    <v-row dense>
      <v-col class="text-h3 gray--text text--lighten-1">
        <PatientsCounter
          queueTitle="Planejamento Cirúrgico"
          queueType="surgical_planning"
        />
      </v-col>
    </v-row>

    <v-row dense>
      <v-col>
        <authorization permissionKey="authorization_queue" can="read">
          <Attendances queueType="surgical_planning" />
        </authorization>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import Attendances from "@/components/queues/attendances.vue";
  import PatientsCounter from "@/components/queues/attendance/patients_counter.vue";

  export default {
    name: "SurgicalPlanningQueue",
    components: {
      Attendances,
      PatientsCounter,
    },
  };
</script>

<style lang="scss" scoped></style>
